import React from 'react';
import { IoIosInformationCircle } from "react-icons/io";


function MessageBox(props) {
  return (
    <div className='flex flex-row bg-yellow-100 p-3 border border-yellow-600 items-center mt-6 '>
        <IoIosInformationCircle fontSize={30} color='#ca8a04'/>
        <span className='text-yellow-800 ml-3 text-sm'>{props.message}</span>
    </div>
  )
}

export default MessageBox